module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-saisie-variable noselect",
    attrs: {
      "data-testid": "saisieDesVariables-section"
    }
  }, [_c('div', {
    staticClass: "area",
    class: _vm.isModified ? 'validation' : ''
  }, [_c('div', {
    staticClass: "head mb-2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head mt-2 mr-2",
    attrs: {
      "data-testid": "saisieDesVariables-title"
    }
  }, [_vm._v("Saisie des variables")]), _vm._v(" "), _c('div', {
    staticClass: "inp-input icon mr-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterVariable),
      expression: "filterVariable"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": !_vm.dataReady,
      "maxlength": "50",
      "placeholder": " ",
      "data-testid": "saisieDesVariables-search-variable-input"
    },
    domProps: {
      "value": (_vm.filterVariable)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilterVariableDebounced()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterVariable = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Rechercher une variable")]), _vm._v(" "), (_vm.filterVariable.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterVariable = '';
        _vm.doFilterVariable()
      }
    }
  })]), _vm._v(" "), (!_vm.isUtilisateurPst) ? _c('div', {
    staticClass: "inp-input icon mr-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCodeFamille),
      expression: "selectedCodeFamille"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.dataReady,
      "id": "sel1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCodeFamille = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.familles), function(famille) {
    return _c('option', {
      domProps: {
        "value": famille.code
      }
    }, [_vm._v(_vm._s(famille.libelle))])
  })), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Catégorie de scénarios")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isUtilisateurPst) ? _c('div', {
    staticClass: "inp-input icon mr-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCodeSousFamille),
      expression: "selectedCodeSousFamille"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.dataReady,
      "id": "sel1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCodeSousFamille = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sousFamille), function(sousFamille) {
    return _c('option', {
      domProps: {
        "value": sousFamille.Code
      }
    }, [_vm._v(_vm._s(sousFamille.Libelle))])
  })), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Scénario")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "blue inp-button-outline mr-2 mt-2",
    attrs: {
      "disabled": !_vm.dataReady || !_vm.allowImportCsv,
      "type": "button",
      "title": "Importer un CSV"
    },
    on: {
      "click": _vm.openImportCsv
    }
  }, [_c('span', {
    staticClass: "fa-regular fa-file-arrow-down"
  })]), _vm._v(" "), (_vm.displaySocietePst) ? _c('button', {
    staticClass: "blue mr-2 mt-2",
    class: _vm.HasMessageInformation ? 'inp-button' : 'inp-button-outline',
    attrs: {
      "type": "button",
      "title": "Définir un message général",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.openMessageContrat(0, 0, 'GENERAL', 'I')
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-comment-dots"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "blue inp-button-outline mr-2 mt-2",
    attrs: {
      "type": "button",
      "title": "Visualiser toutes les variables",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.viewAllDetails()
      }
    }
  }, [_c('span', {
    staticClass: "far fa-eye"
  })]), _vm._v(" "), (_vm.isUtilisateurPst) ? _c('button', {
    staticClass: "inp-button orange mr-2 mt-2",
    attrs: {
      "type": "button",
      "title": "Paramétrage des variables",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.ParamVariables()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-cog"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inp-radio mr-3 mt2"
  }, [_c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio1",
      "id": "oui",
      "value": "oui",
      "disabled": !_vm.dataReady
    },
    domProps: {
      "checked": _vm.dataReady && !_vm.modeSalarieHaut
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "oui",
      "title": "Afficher salarié"
    },
    on: {
      "click": function($event) {
        _vm.changeModeSalarieHaut(false)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-grip-vertical"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio1",
      "id": "non",
      "value": "non",
      "disabled": !_vm.dataReady
    },
    domProps: {
      "checked": _vm.dataReady && _vm.modeSalarieHaut
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "non",
      "title": "Afficher variables"
    },
    on: {
      "click": function($event) {
        _vm.changeModeSalarieHaut(true)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-grip-horizontal"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterName),
      expression: "filterName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": " ",
      "data-testid": "saisieDesVariables-search-salarie-input",
      "disabled": !_vm.dataReady
    },
    domProps: {
      "value": (_vm.filterName)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilterDebounced()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Rechercher un salarié")]), _vm._v(" "), (_vm.filterName.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterName = '';
        _vm.doFilter()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataReady),
      expression: "dataReady"
    }],
    staticClass: "body"
  }, [(_vm.modeSalarieHaut) ? _c('div', {
    staticClass: "vertical body-table"
  }, [_c('table', {
    ref: "scrollTable",
    staticClass: "generic-table",
    attrs: {
      "data-testid": "saisieDesVariables-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "head-sticky-th"
  }, [_c('div', {
    staticClass: "cln-check tw-flex tw-justify-center",
    attrs: {
      "title": "Tout sélectionner"
    }
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "disabled": !_vm.dataReady,
      "id": "allSelected",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }, function($event) {
        _vm.allSelectedChanged(), _vm.checkSelected()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allSelected"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cln-message tw-flex tw-justify-center",
    class: _vm.displayMessageContrat && _vm.displaySocietePst ? 'two' : '',
    attrs: {
      "title": "Message"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Message")])])]), _vm._v(" "), (_vm.rubriqueSpacerAvant) ? _c('th', {
    style: ({
      minWidth: _vm.rubriqueSpacerAvant + 'px',
      width: _vm.rubriqueSpacerAvant + 'px'
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rubriquesVisibles), function(rub) {
    return _c('th', {
      key: 'vh-' + rub.Id,
      staticClass: "head-no-sticky-th",
      attrs: {
        "title": rub.Libelle + ' (' + rub.CodeNature + rub.Code + ')'
      }
    }, [_c('span', {
      staticClass: "text",
      attrs: {
        "data-testid": "saisieDesVariables-variable-label",
        "data-variable": rub.Libelle
      }
    }, [_vm._v("\n                                    (" + _vm._s(rub.CodeNature) + _vm._s(rub.Code) + ")"), _c('br'), _vm._v("\n                                    " + _vm._s(rub.Libelle) + "\n                                ")]), _vm._v(" "), (_vm.canEditVariables) ? _c('button', {
      staticClass: "inp-button btn-menu ml-2",
      attrs: {
        "title": _vm.displayButton ? 'Définir une période' : 'Veuillez sélectionner au moins un salarié',
        "disabled": !_vm.dataReady,
        "disabled": !_vm.displayButton
      },
      on: {
        "click": function($event) {
          _vm.openAddItemForSelected(rub.Id, rub.Code, rub.CodeNature, rub.CodeCategorie)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-ellipsis-v"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.rubriqueSpacerApres) ? _c('th', {
    style: ({
      minWidth: _vm.rubriqueSpacerApres + 'px',
      width: _vm.rubriqueSpacerApres + 'px'
    })
  }) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "line"
  }, [_c('th', {
    staticClass: "line-sticky-th"
  }, [_c('div', {
    staticClass: "section cln-check"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-name"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-salarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-contrat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-message",
    class: _vm.displayMessageContrat && _vm.displaySocietePst ? 'two' : ''
  })]), _vm._v(" "), _c('th', {
    staticClass: "line-no-sticky"
  }, [(_vm.rubriqueSpacerAvant) ? _c('div', {
    staticClass: "section",
    style: ({
      width: _vm.rubriqueSpacerAvant + 'px',
      minWidth: _vm.rubriqueSpacerAvant + 'px'
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rubriquesVisibles), function(rub) {
    return _c('div', {
      key: 'vl-' + rub.Id,
      staticClass: "section cln-rub"
    })
  }), _vm._v(" "), (_vm.rubriqueSpacerApres) ? _c('div', {
    staticClass: "section",
    style: ({
      width: _vm.rubriqueSpacerApres + 'px',
      minWidth: _vm.rubriqueSpacerApres + 'px'
    })
  }) : _vm._e()], 2)]), _vm._v(" "), (_vm.contratSpacerAvant) ? _c('tr', {
    style: ({
      height: _vm.contratSpacerAvant + 'px'
    })
  }, [_c('th')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contratsVisibles), function(contrat, cIdx) {
    return _c('tr', {
      key: 'vc-' + contrat.Id
    }, [_c('th', {
      class: ['body-sticky-th', {
        'odd-bg': (_vm.contratVisibleDebut + cIdx) % 2 !== 0,
        'even-bg': (_vm.contratVisibleDebut + cIdx) % 2 === 0
      }]
    }, [_c('div', {
      staticClass: "cln-check tw-flex tw-justify-center tw-items-center",
      on: {
        "click": function($event) {
          _vm.click_check('selected' + contrat.Id + '_v')
        }
      }
    }, [_c('div', {
      staticClass: "inp-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contrat.selected),
        expression: "contrat.selected"
      }],
      attrs: {
        "disabled": _vm.isSaisieVariableDisabled(contrat),
        "id": 'selected' + contrat.Id + '_v',
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(contrat.selected) ? _vm._i(contrat.selected, null) > -1 : (contrat.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = contrat.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(contrat, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(contrat, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(contrat, "selected", $$c)
          }
        }, function($event) {
          _vm.checkSelected()
        }]
      }
    }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('div', {
      staticClass: "cln-name tw-flex tw-justify-center tw-items-center",
      class: _vm.setClassContratSurExerciceEnCours(contrat),
      attrs: {
        "title": _vm.setTitleName(contrat)
      }
    }, [_c('div', {
      staticClass: "wrap-photo tw-flex tw-justify-center tw-items-center",
      on: {
        "click": function($event) {
          _vm.openSalarie(contrat.IdSalarie, contrat.FullName)
        }
      }
    }, [(contrat.Photo != '') ? _c('img', {
      staticClass: "photo",
      attrs: {
        "src": contrat.Photo,
        "alt": "Photo"
      }
    }) : _c('span', {
      staticClass: "photo",
      style: ({
        background: _vm.randomColor(contrat.Id)
      })
    }, [_vm._v(_vm._s(contrat.Initiales))])]), _vm._v(" "), _c('span', {
      staticClass: "name ml-2",
      attrs: {
        "data-testid": "saisieDesVariables-salarie-name",
        "data-salarie": contrat.FullName
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(contrat.IdSalarie, contrat.FullName)
        }
      }
    }, [_vm._v(_vm._s(contrat.FullName))]), _vm._v(" "), (_vm.containVariable(contrat)) ? _c('button', {
      staticClass: "blue inp-button-outline",
      attrs: {
        "type": "button",
        "title": "Visualiser les variables",
        "disabled": !_vm.dataReady
      },
      on: {
        "click": function($event) {
          _vm.viewDetails(contrat)
        }
      }
    }, [_c('span', {
      staticClass: "far fa-eye"
    })]) : _vm._e(), _vm._v(" "), (!_vm.isUtilisateurPst) ? _c('button', {
      staticClass: "blue inp-button-outline ml-2",
      attrs: {
        "type": "button",
        "title": "Calculer le bulletin",
        "disabled": !_vm.dataReady
      },
      on: {
        "click": function($event) {
          _vm.calculerBulletin(contrat)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-calculator"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "cln-salarie tw-flex tw-justify-center tw-items-center"
    }, [_vm._v(_vm._s(contrat.NumeroSalarie))]), _vm._v(" "), _c('div', {
      staticClass: "cln-contrat tw-flex tw-justify-center tw-items-center",
      attrs: {
        "title": contrat.NumeroContrat
      }
    }, [_vm._v(_vm._s(contrat.NumeroContrat))]), _vm._v(" "), _c('div', {
      staticClass: "cln-message tw-flex tw-justify-center tw-items-center",
      class: _vm.displayMessageContrat && _vm.displaySocietePst ? 'two' : ''
    }, [(_vm.displayMessageContrat) ? _c('button', {
      staticClass: "blue",
      class: contrat.HasMessageContrat ? 'inp-button' : 'inp-button-outline',
      attrs: {
        "type": "button",
        "disabled": !_vm.dataReady,
        "title": 'Définir un message pour le bulletin de ' + contrat.FullName
      },
      on: {
        "click": function($event) {
          _vm.openMessageContrat(contrat.NumeroContrat, contrat.Id, contrat.FullName, 'E')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-envelope fa-fw"
    })]) : _vm._e(), _vm._v(" "), (_vm.displaySocietePst) ? _c('button', {
      staticClass: "turquoise",
      class: contrat.HasMessageInformation ? 'inp-button' : 'inp-button-outline',
      attrs: {
        "type": "button",
        "disabled": !_vm.dataReady,
        "title": 'Définir un message concernant ' + contrat.FullName
      },
      on: {
        "click": function($event) {
          _vm.openMessageContrat(contrat.NumeroContrat, contrat.Id, contrat.FullName, 'I', true)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-envelope fa-fw"
    })]) : _vm._e()])]), _vm._v(" "), (_vm.rubriqueSpacerAvant) ? _c('th', {
      style: ({
        minWidth: _vm.rubriqueSpacerAvant + 'px',
        width: _vm.rubriqueSpacerAvant + 'px'
      })
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rubriquesVisibles), function(rub) {
      return _c('th', {
        key: 'vr-' + rub.Id,
        staticClass: "body-no-sticky-th"
      }, [_c('div', {
        staticClass: "inp-input transparent",
        class: _vm.getPeriode(rub.Code, rub.CodeNature, contrat) != '' ? 'icon' : '',
        attrs: {
          "title": _vm.getPeriode(rub.Code, rub.CodeNature, contrat)
        }
      }, [_c('input', {
        staticClass: "input",
        attrs: {
          "type": "number",
          "disabled": _vm.isSaisieVariableDisabled(contrat),
          "min": "0",
          "max": "10",
          "step": "0.0001",
          "placeholder": " ",
          "data-testid": "saisieDesVariables-montant-input",
          "data-salarie": contrat.FullName,
          "data-variable": rub.Libelle,
          "data-code": rub.CodeNature + rub.Code
        },
        domProps: {
          "value": _vm.getMontant(rub.Code, rub.CodeNature, contrat)
        },
        on: {
          "change": function($event) {
            _vm.onDataChanged(rub.Id, rub.Code, rub.Libelle, rub.CodeNature, rub.CodeCategorie, contrat, $event)
          }
        }
      }), _vm._v(" "), (_vm.getPeriode(rub.Code, rub.CodeNature, contrat) != '') ? _c('span', {
        staticClass: "icon-inner far fa-calendar-alt"
      }) : _vm._e()]), _vm._v(" "), (_vm.getMontant(rub.Code, rub.CodeNature, contrat) != '' && _vm.canEditVariables) ? _c('button', {
        staticClass: "inp-button btn-menu ml-2",
        attrs: {
          "title": "Définir une période",
          "disabled": _vm.isSaisieVariableDisabled(contrat)
        },
        on: {
          "click": function($event) {
            _vm.openPeriodeSettings(rub.Id, rub.Code, rub.CodeNature, contrat)
          }
        }
      }, [_c('span', {
        staticClass: "fas fa-ellipsis-v"
      })]) : _vm._e()])
    }), _vm._v(" "), (_vm.rubriqueSpacerApres) ? _c('th', {
      style: ({
        minWidth: _vm.rubriqueSpacerApres + 'px',
        width: _vm.rubriqueSpacerApres + 'px'
      })
    }) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.contratSpacerApres) ? _c('tr', {
    style: ({
      height: _vm.contratSpacerApres + 'px'
    })
  }, [_c('th')]) : _vm._e()], 2)])]) : _c('div', {
    staticClass: "vertical horizontal body-table"
  }, [_c('table', {
    ref: "scrollTable",
    staticClass: "generic-table",
    attrs: {
      "data-testid": "saisieDesVariables-table"
    }
  }, [_c('thead', [_c('tr', [_vm._m(3), _vm._v(" "), (_vm.contratSpacerAvant) ? _c('th', {
    style: ({
      minWidth: _vm.contratSpacerAvant + 'px',
      width: _vm.contratSpacerAvant + 'px'
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.contratsVisibles), function(contrat) {
    return _c('th', {
      key: 'hh-' + contrat.Id,
      staticClass: "head-no-sticky-th cln-divers",
      class: _vm.setClassContratSurExerciceEnCours(contrat)
    }, [_c('div', {
      staticClass: "left mr-2",
      attrs: {
        "title": _vm.setTitleName(contrat)
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(contrat.IdSalarie, contrat.FullName)
        }
      }
    }, [(contrat.Photo != '') ? _c('img', {
      staticClass: "photo",
      attrs: {
        "src": contrat.Photo,
        "alt": "Photo"
      }
    }) : _c('span', {
      staticClass: "photo",
      style: ({
        background: _vm.randomColor(contrat.Id)
      })
    }, [_vm._v(_vm._s(contrat.Initiales))])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "top mb-1",
      attrs: {
        "title": _vm.setTitleName(contrat)
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(contrat.IdSalarie, contrat.FullName)
        }
      }
    }, [_c('span', {
      staticClass: "name",
      attrs: {
        "data-testid": "saisieDesVariables-salarie-name",
        "data-salarie": contrat.FullName
      }
    }, [_vm._v(_vm._s(contrat.FullName))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('div', {
      staticClass: "left",
      attrs: {
        "title": ' N° C : ' + contrat.NumeroContrat + ' N° S : ' + contrat.NumeroSalarie
      }
    }, [_c('div', {
      staticClass: "top num-contrat-area",
      attrs: {
        "title": contrat.NumeroContrat
      }
    }, [_vm._v("N° C : " + _vm._s(contrat.NumeroContrat))]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_vm._v("N° S : " + _vm._s(contrat.NumeroSalarie))])]), _vm._v(" "), _c('div', {
      staticClass: "right",
      class: _vm.displayMessageContrat && _vm.displaySocietePst ? 'two' : ''
    }, [(_vm.displayMessageContrat) ? _c('button', {
      staticClass: "blue",
      class: contrat.HasMessageContrat ? 'inp-button' : 'inp-button-outline',
      attrs: {
        "type": "button",
        "disabled": !_vm.dataReady,
        "title": 'Définir un message pour le bulletin de ' + contrat.FullName
      },
      on: {
        "click": function($event) {
          _vm.openMessageContrat(contrat.NumeroContrat, contrat.Id, contrat.FullName, 'E')
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-envelope fa-fw"
    })]) : _vm._e(), _vm._v(" "), (_vm.displaySocietePst) ? _c('button', {
      staticClass: "turquoise",
      class: contrat.HasMessageInformation ? 'inp-button' : 'inp-button-outline',
      attrs: {
        "type": "button",
        "disabled": !_vm.dataReady,
        "title": 'Définir un message concernant ' + contrat.FullName
      },
      on: {
        "click": function($event) {
          _vm.openMessageContrat(contrat.NumeroContrat, contrat.Id, contrat.FullName, 'I', true)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-envelope fa-fw"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sep"
    })])])])])
  }), _vm._v(" "), (_vm.contratSpacerApres) ? _c('th', {
    style: ({
      minWidth: _vm.contratSpacerApres + 'px',
      width: _vm.contratSpacerApres + 'px'
    })
  }) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "line"
  }, [_vm._m(4), _vm._v(" "), _c('th', {
    staticClass: "line-no-sticky"
  }, [(_vm.contratSpacerAvant) ? _c('div', {
    staticClass: "section",
    style: ({
      width: _vm.contratSpacerAvant + 'px',
      minWidth: _vm.contratSpacerAvant + 'px'
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.contratsVisibles), function(contrat) {
    return _c('div', {
      key: 'hl-' + contrat.Id,
      staticClass: "section cln-rub"
    })
  }), _vm._v(" "), (_vm.contratSpacerApres) ? _c('div', {
    staticClass: "section",
    style: ({
      width: _vm.contratSpacerApres + 'px',
      minWidth: _vm.contratSpacerApres + 'px'
    })
  }) : _vm._e()], 2)]), _vm._v(" "), (_vm.rubriqueSpacerAvant) ? _c('tr', {
    style: ({
      height: _vm.rubriqueSpacerAvant + 'px'
    })
  }, [_c('th')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rubriquesVisibles), function(rub, vIdx) {
    return _c('tr', {
      key: 'hr-' + rub.Id
    }, [_c('th', {
      class: ['body-sticky-th', {
        'odd-bg': (_vm.rubriqueVisibleDebut + vIdx) % 2 !== 0,
        'even-bg': (_vm.rubriqueVisibleDebut + vIdx) % 2 === 0
      }]
    }, [_c('div', {
      staticClass: "cln-variable",
      attrs: {
        "title": rub.Libelle + ' (' + rub.CodeNature + rub.Code + ')'
      }
    }, [_c('span', {
      staticClass: "text",
      attrs: {
        "data-testid": "saisieDesVariables-variable-label",
        "data-variable": rub.Libelle
      }
    }, [_vm._v("\n                                        " + _vm._s(rub.Libelle) + " (" + _vm._s(rub.CodeNature) + _vm._s(rub.Code) + ")\n                                    ")])])]), _vm._v(" "), (_vm.contratSpacerAvant) ? _c('th', {
      style: ({
        minWidth: _vm.contratSpacerAvant + 'px',
        width: _vm.contratSpacerAvant + 'px'
      })
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.contratsVisibles), function(contrat) {
      return _c('th', {
        key: 'hc-' + contrat.Id,
        staticClass: "body-no-sticky-th"
      }, [_c('div', {
        staticClass: "inp-input transparent",
        class: _vm.getPeriode(rub.Code, rub.CodeNature, contrat) != '' ? 'icon' : '',
        attrs: {
          "title": _vm.getPeriode(rub.Code, rub.CodeNature, contrat)
        }
      }, [_c('input', {
        staticClass: "input",
        attrs: {
          "type": "number",
          "disabled": _vm.isSaisieVariableDisabled(contrat),
          "min": "0",
          "max": "10",
          "step": "0.0001",
          "placeholder": " ",
          "data-testid": "saisieDesVariables-montant-input",
          "data-salarie": contrat.FullName,
          "data-variable": rub.Libelle,
          "data-code": rub.CodeNature + rub.Code
        },
        domProps: {
          "value": _vm.getMontant(rub.Code, rub.CodeNature, contrat)
        },
        on: {
          "change": function($event) {
            _vm.onDataChanged(rub.Id, rub.Code, rub.Libelle, rub.CodeNature, rub.CodeCategorie, contrat, $event)
          }
        }
      }), _vm._v(" "), (_vm.getPeriode(rub.Code, rub.CodeNature, contrat) != '') ? _c('span', {
        staticClass: "icon-inner far fa-calendar-alt"
      }) : _vm._e()]), _vm._v(" "), (_vm.getMontant(rub.Code, rub.CodeNature, contrat) != '' && _vm.canEditVariables) ? _c('button', {
        staticClass: "inp-button btn-menu ml-2",
        attrs: {
          "title": "Définir une période",
          "disabled": _vm.isSaisieVariableDisabled(contrat)
        },
        on: {
          "click": function($event) {
            _vm.openPeriodeSettings(rub.Id, rub.Code, rub.CodeNature, contrat)
          }
        }
      }, [_c('span', {
        staticClass: "fas fa-ellipsis-v"
      })]) : _vm._e()])
    }), _vm._v(" "), (_vm.contratSpacerApres) ? _c('th', {
      style: ({
        minWidth: _vm.contratSpacerApres + 'px',
        width: _vm.contratSpacerApres + 'px'
      })
    }) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.rubriqueSpacerApres) ? _c('tr', {
    style: ({
      height: _vm.rubriqueSpacerApres + 'px'
    })
  }, [_c('th')]) : _vm._e()], 2)])])]), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dataReady),
      expression: "!dataReady"
    }]
  })], 1), _vm._v(" "), (_vm.isModified) ? _c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dataReady,
      "data-testid": "saisieDesVariables-valider-button"
    },
    on: {
      "click": function($event) {
        _vm.enregistrer()
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button",
      "data-testid": "saisieDesVariables-annuler-button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])]) : _vm._e(), _vm._v(" "), _c('modal-recap-variables', {
    ref: "modalRecapVariables"
  }), _vm._v(" "), _c('modal-recap-all-variables', {
    ref: "modalRecapAllVariables"
  }), _vm._v(" "), _c('modal-calcul-bulletin', {
    ref: "modalCalculBulletin"
  }), _vm._v(" "), _c('modal-message', {
    ref: "modalMessage",
    on: {
      "messageAdded": _vm.messageAdded,
      "messageDeleted": _vm.messageDeleted
    }
  }), _vm._v(" "), _c('modal-ajout-periode-variable', {
    ref: "modalAjoutPeriodeVariable",
    on: {
      "validate": _vm.validatePeriode
    }
  }), _vm._v(" "), _c('modal-param-variables-pst', {
    ref: "modalParamVariablesPst",
    on: {
      "updateCompleted": function($event) {
        _vm.onSelectedCodeSousFamilleChanged('', '')
      }
    }
  }), _vm._v(" "), _c('modal-import-csv', {
    ref: "modalImportCsv",
    on: {
      "validate": _vm.validateImport
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cln-name tw-flex tw-justify-center",
    attrs: {
      "title": "Nom / Prénom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom / Prénom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cln-salarie tw-flex tw-justify-center",
    attrs: {
      "title": "N° Salarié"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cln-contrat tw-flex tw-justify-center",
    attrs: {
      "title": "N° Contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° C")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "head-sticky-th"
  }, [_c('div', {
    staticClass: "cln-variable",
    attrs: {
      "title": "Variables"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Variables")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "line-sticky-th"
  }, [_c('div', {
    staticClass: "section cln-variable"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65897e38"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/saisieDesVariables/saisieDesVariables.vue.html
// module id = Jux5
// module chunks = 2